import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import toast from 'react-hot-toast';
import { UPDATE_INDICATOR_SLA } from '../../Utils/constant';
import { store } from '../../services/service';
import { useSlaStore } from '../../store/Paramettre/slaStore';

export const SLAConfig = ({ description, message, defaultValue, param, periode }) => {
    const [isSubmit, setIsSubmit] = useState(false);
    const [value, setValue] = useState(defaultValue);
    const [period, setPeriod] = useState(periode)

    const {
        register,
        handleSubmit, reset,
    } = useForm()
    const sla = useSlaStore()
    const submit = (data) => {
        setIsSubmit(true)
        store(UPDATE_INDICATOR_SLA, 'application/json', { ...data, indicateur: param }).then(() => {
            toast.success(message)
            setIsSubmit(false)
            reset()
            sla.getData()
        }).catch((err) => {
            console.log(err);
            setIsSubmit(null)
            toast.error("Une erreur s'est produite !")
        })
    }


    return (
        <>
            <div className="font-mtn my-2 border bg-white w-fit rounded-xl">
                <form onSubmit={handleSubmit(submit)} className="flex gap-3 px-8 py-4">
                    <div className='space-x-2'>
                        <label className="text-sm font-medium text-gray-900">
                            {description}<span className="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            {...register('valeur', { required: true })}
                            onChange={(e) => setValue(e.target.value)}
                            defaultValue={defaultValue}
                            className="input input-bordered text-gray-500 h-10 text-sm font-semibold"

                        />
                    </div>
                    {
                        periode !== null ? (
                            <div className='space-x-2'>
                                <label className="text-sm">Periode <span className="text-red-500">*</span></label>
                                <select value={period} {...register('periode', { required: true })}
                                    onChange={(e) => {
                                        setPeriod(e.target.value)
                                    }}
                                    className="select select-bordered w-full lg:w-32 h-10" >
                                    <option value="JOUR">
                                        Jours
                                    </option>
                                    <option value="HEURE">
                                        Heures
                                    </option>
                                    <option value="MINUTE">
                                        Minutes
                                    </option>
                                </select>
                            </div>

                        ) : null
                    }

                    <button
                        type="submit"
                        onClick={() => {

                        }}
                        disabled={isSubmit ? true : false}
                        className={`${!isSubmit
                            ? "text-black bg-main"
                            : "text-slate-800 bg-slate-200 "
                            }  btn btn-sm`}
                    >
                        {!isSubmit ? "Appliquer" : "Veuillez patientez..."}{" "}
                        {isSubmit ? (
                            <span className="loading loading-dots loading-xs"></span>
                        ) : null}
                    </button>

                </form>
            </div >
        </>
    )
}
